import { render, staticRenderFns } from "./LegalDocumentContent_Ti8nYX.vue?vue&type=template&id=759dfa26&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_Ti8nYX.vue?vue&type=style&index=0&id=759dfa26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759dfa26",
  null
  
)

export default component.exports